import React, {Component, PropTypes} from 'react'
import cx from 'classnames'
import style from './Icon.less'

export function sanitize(value) {
    if (value) {
        value = value.toString()
        value = value === value.toUpperCase() && value.toLowerCase() || value
        value = value.charAt(0).toLowerCase() + value.slice(1)
    }
    return value
}

class Icon extends Component {
    static propTypes = {
        icon: PropTypes.string.isRequired,
        size: PropTypes.string.isRequired,
        active: PropTypes.bool,
        count: PropTypes.any,
        status: PropTypes.string
    }

    render() {
        const {icon, size, count, active, status, ...other} = this.props
        const iconClass = icon && sanitize(icon)
        const sizeClass = size && size.toLowerCase()
        const statusClass = status && status.toLowerCase()

        return (
            <i
                className={cx(style.default, style[iconClass], style[sizeClass], {[style.active]: active})}
                {...other}>
                {count && (
                    <span className={cx(style.count, style[statusClass])}>
                        {count}
                    </span>
                ) || null}
            </i>
        )
    }
}

export default Icon


// WEBPACK FOOTER //
// ./lib/core/components/Icon.js